import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
const CHECK_MS = 60000;
let knownVersion = null;

async function fetchVersion() {
  const r = await axios.get(`${API}/site-version`, { params: { t: Date.now() } });
  return String(r.data?.version ?? '0');
}

/**
 * Watches the published site version. When an admin hits "Yayınla" (or a deploy bumps
 * the version), every open visitor tab hard-reloads within ~1 minute so nobody keeps
 * seeing stale content. Admin users and /admin pages are never auto-reloaded.
 */
export default function VersionWatcher() {
  useEffect(() => {
    let timer;
    const check = async () => {
      if (window.location.pathname.startsWith('/admin')) return;
      if (localStorage.getItem('yekuv_token')) return; // never yank the page from editors
      try {
        const v = await fetchVersion();
        if (knownVersion === null) { knownVersion = v; return; }
        if (v !== knownVersion) window.location.reload();
      } catch { /* offline / transient — try again next tick */ }
    };
    check();
    timer = setInterval(check, CHECK_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { clearInterval(timer); document.removeEventListener('visibilitychange', onVisible); };
  }, []);
  return null;
}
